module.exports = __webpack_public_path__ + "img/6.b18575c1.png";